import React from 'react'

const AdminTours = () => {
  return (
    <div className="min-h-screen bg-base-100 pt-0 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-base-content mb-4">
            Manage Tours
          </h1>
          <p className="text-xl text-base-content/70">
            Add, edit, and manage tour packages
          </p>
        </div>
      </div>
    </div>
  )
}

export default AdminTours
